// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2j8m8","search":"Settings_search__1qPT_","filter":"Settings_filter__18d0r"};